<!--&lt;!&ndash; Navbar&ndash;&gt;-->
<!--&lt;!&ndash; Remove "navbar-sticky" class to make navigation bar scrollable with the page.&ndash;&gt;-->
<!--<header class="navbar navbar-sticky">-->

<!--  <app-search (onHideSearch)="showSearch = false" [showSearch]="showSearch" class="site-search-wrapper"></app-search>-->

<!--  &lt;!&ndash; Logo &ndash;&gt;-->
<!--  <div class="site-branding">-->
<!--    <a routerLink="/" class="flex items-center space-x-2">-->
<!--      <img src="https://www.laparfumerie.eu/static/version1745586722/frontend/Synolia/laparfumerieeurope/fr_FR/svg/logo.svg" alt="La Parfumerie Europe" class="h-10">-->
<!--    </a>-->
<!--  </div>-->
<!--  <app-navigation-main></app-navigation-main>-->

<!--    &lt;!&ndash; Toolbar&ndash;&gt;-->
<!--  <div class="toolbar">-->
<!--    <div class="inner">-->
<!--      <div class="tools">-->
<!--        <div class="search">-->
<!--          <i (click)="showSearch = true" class="icon-search"></i>-->
<!--        </div>-->
<!--&lt;!&ndash;-->
<!--        <div class="account">-->
<!--          <a *ngIf="!user; else whenLoggedIn" routerLink="/register-login"></a>-->

<!--          <ng-template #whenLoggedIn>-->
<!--            <a routerLink="/account/profile"></a>-->
<!--          </ng-template>-->

<!--          <i class="icon-head"></i>-->
<!--          <ul *ngIf="user" class="toolbar-dropdown">-->
<!--            <li class="sub-menu-user">-->
<!--              <div class="user-info">-->
<!--                <h6 class="user-name">{{ user?.email }}-->
<!--                  <span *ngIf="user?.roles?.admin"> (Admin)</span>-->
<!--                </h6>-->
<!--              </div>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a routerLink="/account/profile" href="">My Profile</a>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a routerLink="/account/orders" href="">Orders List</a>-->
<!--            </li>-->
<!--            <li class="sub-menu-separator"></li>-->
<!--            <li>-->
<!--              <a href="" (click)="onLogOut($event)">-->
<!--                <i class="icon-unlock"></i>Logout</a>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->
<!--&ndash;&gt;-->

<!--        <app-toolbar-cart></app-toolbar-cart>-->

<!--      </div>-->
<!--    </div>-->
<!--  </div>-->


<!--&lt;!&ndash;  <div class="bg-gray-900 text-white py-3">-->
<!--    <div class="max-w-7xl mx-auto px-6">-->
<!--      <div class="flex items-center justify-end space-x-6">-->
<!--        &lt;!&ndash; Search &ndash;&gt;-->
<!--        <div class="search">-->
<!--          <button (click)="showSearch = true" class="text-gray-300 hover:text-gold transition duration-300">-->
<!--            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>-->
<!--            </svg>-->
<!--          </button>-->
<!--        </div>-->

<!--        &lt;!&ndash; Account &ndash;&gt;-->
<!--        <div class="account relative">-->
<!--          <a *ngIf="!user; else whenLoggedIn" routerLink="/register-login" class="text-gray-300 hover:text-gold transition duration-300 flex items-center space-x-2">-->
<!--            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>-->
<!--            </svg>-->
<!--          </a>-->

<!--          <ng-template #whenLoggedIn>-->
<!--            <a routerLink="/account/profile" class="text-gray-300 hover:text-gold transition duration-300 flex items-center space-x-2">-->
<!--              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>-->
<!--              </svg>-->
<!--              <span>{{ user?.email }}</span>-->
<!--            </a>-->
<!--          </ng-template>-->

<!--          <ul *ngIf="user" class="absolute right-0 mt-2 w-48 bg-white text-gray-900 rounded-lg shadow-lg py-2 z-50">-->
<!--            <li class="px-4 py-2">-->
<!--              <div class="text-sm font-serif text-gold">-->
<!--                {{ user?.email }}-->
<!--                <span *ngIf="user?.roles?.admin" class="text-gray-600"> (Admin)</span>-->
<!--              </div>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a routerLink="/account/profile" href="" class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300">My Profile</a>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a routerLink="/account/orders" href="" class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300">Orders List</a>-->
<!--            </li>-->
<!--            <li><hr class="border-gray-200 mx-2"></li>-->
<!--            <li>-->
<!--              <a href="" (click)="onLogOut($event)" class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300 flex items-center space-x-2">-->
<!--                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">-->
<!--                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>-->
<!--                </svg>-->
<!--                <span>Logout</span>-->
<!--              </a>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->

<!--        &lt;!&ndash; Cart &ndash;&gt;-->
<!--        <app-toolbar-cart></app-toolbar-cart>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>&ndash;&gt;-->
<!--</header>-->


<!--
<header class="navbar bg-white shadow-md">
  <div class="container mx-auto px-2 sm:px-4 flex flex-col">
    &lt;!&ndash; Top Section: Logo, Toolbar, and Toggle Menu &ndash;&gt;
    <div class="flex items-center justify-between py-2 sm:py-3">
      &lt;!&ndash; Mobile Menu Toggle (Left on Mobile) &ndash;&gt;
      <button
        class="lg:hidden text-gray-600 hover:text-gold focus:outline-none p-2 order-1"
        (click)="onMenuToggle($event)"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16m-7 6h7"
          ></path>
        </svg>
      </button>

      &lt;!&ndash; Logo (Centered on Mobile) &ndash;&gt;
      <div class="site-branding order-2 mx-auto lg:mx-0">
        <a routerLink="/" class="flex items-center justify-center space-x-2">
          <img
            src="https://www.laparfumerie.eu/static/version1745586722/frontend/Synolia/laparfumerieeurope/fr_FR/svg/logo.svg"
            alt="La Parfumerie Europe"
            class="h-8 sm:h-10"
          >
        </a>
      </div>

      &lt;!&ndash; Toolbar (Search, Account, Cart) &ndash;&gt;
      <div class="toolbar order-3">
        <div class="inner flex items-center space-x-2 sm:space-x-4">
          <div class="tools flex items-center space-x-2 sm:space-x-4">
            &lt;!&ndash; Search &ndash;&gt;
            <div class="search">
              <button
                (click)="showSearch = true"
                class="text-gray-600 hover:text-gold p-1 sm:p-2"
              >
                <svg
                  class="w-5 h-5 sm:w-6 sm:h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  ></path>
                </svg>
              </button>
            </div>

            &lt;!&ndash; Account &ndash;&gt;
            <div class="account relative">
              <a
                *ngIf="!user; else whenLoggedIn"
                routerLink="/register-login"
                class="text-gray-600 hover:text-gold p-1 sm:p-2"
              >
                <svg
                  class="w-5 h-5 sm:w-6 sm:h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  ></path>
                </svg>
              </a>

              <ng-template #whenLoggedIn>
                <a
                  routerLink="/account/profile"
                  class="text-gray-600 hover:text-gold p-1 sm:p-2 flex items-center space-x-1 sm:space-x-2"
                >
                  <svg
                    class="w-5 h-5 sm:w-6 sm:h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    ></path>
                  </svg>
                  <span class="text-xs sm:text-sm">{{ user?.email }}</span>
                </a>
              </ng-template>

              <ul
                *ngIf="user"
                class="absolute right-0 mt-2 w-48 bg-white text-gray-900 rounded-lg shadow-lg py-2 z-50"
              >
                <li class="px-4 py-2">
                  <div class="text-sm font-serif text-gold">
                    {{ user?.email }}
                    <span
                      *ngIf="user?.roles?.admin"
                      class="text-gray-600"
                    >
                      (Admin)
                    </span>
                  </div>
                </li>
                <li>
                  <a
                    routerLink="/account/profile"
                    href=""
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300"
                  >
                    My Profile
                  </a>
                </li>
                <li>
                  <a
                    routerLink="/account/orders"
                    href=""
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300"
                  >
                    Orders List
                  </a>
                </li>
                <li>
                  <hr class="border-gray-200 mx-2">
                </li>
                <li>
                  <a
                    href=""
                    (click)="onLogOut($event)"
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300 flex items-center space-x-2"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                      ></path>
                    </svg>
                    <span>Logout</span>
                  </a>
                </li>
              </ul>
            </div>

            &lt;!&ndash; Cart &ndash;&gt;
            <app-toolbar-cart></app-toolbar-cart>
          </div>
        </div>
      </div>
    </div>

    &lt;!&ndash; Search Overlay &ndash;&gt;
    <app-search
      (onHideSearch)="showSearch = false"
      [showSearch]="showSearch"
      class="site-search-wrapper"
    ></app-search>

    &lt;!&ndash; Navigation &ndash;&gt;
    <div class="site-menu bg-gray-50 shadow-sm py-2 sm:py-3">
      <app-navigation-main [isMobileMenuOpen]="isMobileMenuOpen"></app-navigation-main>
    </div>
  </div>
</header>
-->


<!--
<header class="navbar bg-white shadow-md">
  <div class="container mx-auto px-2 sm:px-4 flex flex-col">
    &lt;!&ndash; Top Section: Logo, Toolbar, and Toggle Menu &ndash;&gt;
    <div class="flex items-center justify-between py-2 sm:py-3">
      &lt;!&ndash; Mobile Menu Toggle (Left on Mobile) &ndash;&gt;
      <button
        class="lg:hidden text-gray-600 hover:text-gold focus:outline-none p-2 order-1"
        (click)="onMenuToggle($event)"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16m-7 6h7"
          ></path>
        </svg>
      </button>

      &lt;!&ndash; Logo (Centered on Mobile) &ndash;&gt;
      <div class="site-branding order-2 mx-auto lg:mx-0">
        <a routerLink="/" class="flex items-center justify-center space-x-2">
          <img
            src="https://www.laparfumerie.eu/static/version1745586722/frontend/Synolia/laparfumerieeurope/fr_FR/svg/logo.svg"
            alt="La Parfumerie Europe"
            class="h-8 sm:h-10"
          >
        </a>
      </div>

      &lt;!&ndash; Toolbar (Search, Account, Cart) &ndash;&gt;
      <div class="toolbar order-3">
        <div class="inner flex items-center space-x-2 sm:space-x-4">
          <div class="tools flex items-center space-x-2 sm:space-x-4">
            &lt;!&ndash; Search &ndash;&gt;
            <div class="search">
              <button
                (click)="showSearch = true"
                class="text-gray-600 hover:text-gold p-1 sm:p-2"
              >
                <svg
                  class="w-5 h-5 sm:w-6 sm:h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  ></path>
                </svg>
              </button>
            </div>

            &lt;!&ndash; Account &ndash;&gt;
            <div class="account relative">
              <a
                *ngIf="!user; else whenLoggedIn"
                routerLink="/register-login"
                class="text-gray-600 hover:text-gold p-1 sm:p-2"
              >
                <svg
                  class="w-5 h-5 sm:w-6 sm:h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  ></path>
                </svg>
              </a>

              <ng-template #whenLoggedIn>
                <a
                  routerLink="/account/profile"
                  class="text-gray-600 hover:text-gold p-1 sm:p-2 flex items-center space-x-1 sm:space-x-2"
                >
                  <svg
                    class="w-5 h-5 sm:w-6 sm:h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    ></path>
                  </svg>
                  <span class="text-xs sm:text-sm">{{ user?.email }}</span>
                </a>
              </ng-template>

              <ul
                *ngIf="user"
                class="absolute right-0 mt-2 w-48 bg-white text-gray-900 rounded-lg shadow-lg py-2 z-50"
              >
                <li class="px-4 py-2">
                  <div class="text-sm font-serif text-gold">
                    {{ user?.email }}
                    <span
                      *ngIf="user?.roles?.admin"
                      class="text-gray-600"
                    >
                      (Admin)
                    </span>
                  </div>
                </li>
                <li>
                  <a
                    routerLink="/account/profile"
                    href=""
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300"
                  >
                    My Profile
                  </a>
                </li>
                <li>
                  <a
                    routerLink="/account/orders"
                    href=""
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300"
                  >
                    Orders List
                  </a>
                </li>
                <li>
                  <hr class="border-gray-200 mx-2">
                </li>
                <li>
                  <a
                    href=""
                    (click)="onLogOut($event)"
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300 flex items-center space-x-2"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                      ></path>
                    </svg>
                    <span>Logout</span>
                  </a>
                </li>
              </ul>
            </div>

            &lt;!&ndash; Cart &ndash;&gt;
            <app-toolbar-cart></app-toolbar-cart>
          </div>
        </div>
      </div>
    </div>

    &lt;!&ndash; Search Overlay &ndash;&gt;
    <app-search
      (onHideSearch)="showSearch = false"
      [showSearch]="showSearch"
      class="site-search-wrapper"
    ></app-search>

    &lt;!&ndash; Navigation &ndash;&gt;
    <div class="site-menu bg-gray-50 shadow-sm py-2 sm:py-3">
      <app-navigation-main [isMobileMenuOpen]="isMobileMenuOpen"></app-navigation-main>
    </div>
  </div>
</header>
-->


<!--
<header class="navbar bg-white shadow-md">
  <div class="container mx-auto px-2 sm:px-4 flex flex-col">
    &lt;!&ndash; Top Section: Logo, Toolbar, and Toggle Menu &ndash;&gt;
    <div class="flex items-center justify-between py-2 sm:py-3">
      &lt;!&ndash; Mobile Menu Toggle (Left on Mobile) &ndash;&gt;
      <button
        class="lg:hidden text-gray-600 hover:text-gold focus:outline-none p-2 order-1"
        (click)="onMenuToggle($event)"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16m-7 6h7"
          ></path>
        </svg>
      </button>

      &lt;!&ndash; Logo (Centered on Mobile) &ndash;&gt;
      <div class="site-branding order-2 mx-auto lg:mx-0">
        <a routerLink="/" class="flex items-center justify-center space-x-2">
          <img
            src="https://www.laparfumerie.eu/static/version1745586722/frontend/Synolia/laparfumerieeurope/fr_FR/svg/logo.svg"
            alt="La Parfumerie Europe"
            class="h-8 sm:h-10"
          >
        </a>
      </div>

      &lt;!&ndash; Toolbar (Search, Account, Cart) &ndash;&gt;
      <div class="toolbar order-3">
        <div class="inner flex items-center space-x-2 sm:space-x-4">
          <div class="tools flex items-center space-x-2 sm:space-x-4">
            &lt;!&ndash; Search &ndash;&gt;
            <div class="search">
              <button
                (click)="showSearch = true"
                class="text-gray-600 hover:text-gold p-1 sm:p-2"
              >
                <svg
                  class="w-5 h-5 sm:w-6 sm:h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  ></path>
                </svg>
              </button>
            </div>

            &lt;!&ndash; Account &ndash;&gt;
            <div class="account relative">
              <a
                *ngIf="!user; else whenLoggedIn"
                routerLink="/register-login"
                class="text-gray-600 hover:text-gold p-1 sm:p-2"
              >
                <svg
                  class="w-5 h-5 sm:w-6 sm:h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  ></path>
                </svg>
              </a>

              <ng-template #whenLoggedIn>
                <a
                  routerLink="/account/profile"
                  class="text-gray-600 hover:text-gold p-1 sm:p-2 flex items-center space-x-1 sm:space-x-2"
                >
                  <svg
                    class="w-5 h-5 sm:w-6 sm:h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    ></path>
                  </svg>
                  <span class="text-xs sm:text-sm">{{ user?.email }}</span>
                </a>
              </ng-template>

              <ul
                *ngIf="user"
                class="absolute right-0 mt-2 w-48 bg-white text-gray-900 rounded-lg shadow-lg py-2 z-50"
              >
                <li class="px-4 py-2">
                  <div class="text-sm font-serif text-gold">
                    {{ user?.email }}
                    <span
                      *ngIf="user?.roles?.admin"
                      class="text-gray-600"
                    >
                      (Admin)
                    </span>
                  </div>
                </li>
                <li>
                  <a
                    routerLink="/account/profile"
                    href=""
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300"
                  >
                    My Profile
                  </a>
                </li>
                <li>
                  <a
                    routerLink="/account/orders"
                    href=""
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300"
                  >
                    Orders List
                  </a>
                </li>
                <li>
                  <hr class="border-gray-200 mx-2">
                </li>
                <li>
                  <a
                    href=""
                    (click)="onLogOut($event)"
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300 flex items-center space-x-2"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                      ></path>
                    </svg>
                    <span>Logout</span>
                  </a>
                </li>
              </ul>
            </div>

            &lt;!&ndash; Cart &ndash;&gt;
            <app-toolbar-cart></app-toolbar-cart>
          </div>
        </div>
      </div>
    </div>

    &lt;!&ndash; Search Overlay &ndash;&gt;
    <app-search
      (onHideSearch)="showSearch = false"
      [showSearch]="showSearch"
      class="site-search-wrapper"
    ></app-search>

    &lt;!&ndash; Navigation &ndash;&gt;
    <div class="site-menu bg-gray-50 shadow-sm py-2 sm:py-3">
      <app-navigation-main [isMobileMenuOpen]="isMobileMenuOpen"></app-navigation-main>
    </div>
  </div>
</header>
-->


<!--
<header class="navbar bg-white shadow-md">
  <div class="container mx-auto px-2 sm:px-4 flex flex-col">
    &lt;!&ndash; Top Section: Logo, Toolbar, and Toggle Menu &ndash;&gt;
    <div class="flex items-center justify-between py-2 sm:py-3">
      &lt;!&ndash; Mobile Menu Toggle (Left on Mobile) &ndash;&gt;
      <button
        class="lg:hidden text-gray-600 hover:text-gold focus:outline-none p-2 order-1"
        (click)="onMenuToggle($event)"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16m-7 6h7"
          ></path>
        </svg>
      </button>

      &lt;!&ndash; Logo (Centered on Mobile) &ndash;&gt;
      <div class="site-branding order-2 mx-auto lg:mx-0">
        <a routerLink="/" class="flex items-center justify-center space-x-2">
          <img
            src="https://www.laparfumerie.eu/static/version1745586722/frontend/Synolia/laparfumerieeurope/fr_FR/svg/logo.svg"
            alt="La Parfumerie Europe"
            class="h-8 sm:h-10"
          >
        </a>
      </div>

      &lt;!&ndash; Toolbar (Search, Account, Cart) &ndash;&gt;
      <div class="toolbar order-3">
        <div class="inner flex items-center space-x-2 sm:space-x-4">
          <div class="tools flex items-center space-x-2 sm:space-x-4">
            &lt;!&ndash; Search &ndash;&gt;
            <div class="search">
              <button
                (click)="showSearch = true"
                class="text-gray-600 hover:text-gold p-1 sm:p-2"
              >
                <svg
                  class="w-5 h-5 sm:w-6 sm:h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  ></path>
                </svg>
              </button>
            </div>

            &lt;!&ndash; Account &ndash;&gt;
            <div class="account relative">
              <a
                *ngIf="!user; else whenLoggedIn"
                routerLink="/register-login"
                class="text-gray-600 hover:text-gold p-1 sm:p-2"
              >
                <svg
                  class="w-5 h-5 sm:w-6 sm:h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  ></path>
                </svg>
              </a>

              <ng-template #whenLoggedIn>
                <a
                  routerLink="/account/profile"
                  class="text-gray-600 hover:text-gold p-1 sm:p-2 flex items-center space-x-1 sm:space-x-2"
                >
                  <svg
                    class="w-5 h-5 sm:w-6 sm:h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    ></path>
                  </svg>
                  <span class="text-xs sm:text-sm">{{ user?.email }}</span>
                </a>
              </ng-template>

              <ul
                *ngIf="user"
                class="absolute right-0 mt-2 w-48 bg-white text-gray-900 rounded-lg shadow-lg py-2 z-50"
              >
                <li class="px-4 py-2">
                  <div class="text-sm font-serif text-gold">
                    {{ user?.email }}
                    <span
                      *ngIf="user?.roles?.admin"
                      class="text-gray-600"
                    >
                      (Admin)
                    </span>
                  </div>
                </li>
                <li>
                  <a
                    routerLink="/account/profile"
                    href=""
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300"
                  >
                    My Profile
                  </a>
                </li>
                <li>
                  <a
                    routerLink="/account/orders"
                    href=""
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300"
                  >
                    Orders List
                  </a>
                </li>
                <li>
                  <hr class="border-gray-200 mx-2">
                </li>
                <li>
                  <a
                    href=""
                    (click)="onLogOut($event)"
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300 flex items-center space-x-2"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                      ></path>
                    </svg>
                    <span>Logout</span>
                  </a>
                </li>
              </ul>
            </div>

            &lt;!&ndash; Cart &ndash;&gt;
            <app-toolbar-cart></app-toolbar-cart>
          </div>
        </div>
      </div>
    </div>

    &lt;!&ndash; Search Overlay &ndash;&gt;
    <app-search
      (onHideSearch)="showSearch = false"
      [showSearch]="showSearch"
      class="site-search-wrapper"
    ></app-search>

    &lt;!&ndash; Navigation &ndash;&gt;
    <div class="site-menu bg-gray-50 shadow-sm py-2 sm:py-3">
      <app-navigation-main [isMobileMenuOpen]="isMobileMenuOpen"></app-navigation-main>
    </div>
  </div>
</header>
-->


<!--
<header class="navbar bg-white shadow-md">
  <div class="container mx-auto px-2 sm:px-4 flex flex-col">
    &lt;!&ndash; Top Section: Logo, Toolbar, and Toggle Menu &ndash;&gt;
    <div class="flex items-center justify-between py-2 sm:py-3">
      &lt;!&ndash; Mobile Menu Toggle (Left on Mobile) &ndash;&gt;
      <button
        class="lg:hidden text-gray-600 hover:text-gold focus:outline-none p-2 order-1"
        (click)="onMenuToggle($event)"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16m-7 6h7"
          ></path>
        </svg>
      </button>

      &lt;!&ndash; Logo (Centered on Mobile) &ndash;&gt;
      <div class="site-branding order-2 mx-auto lg:mx-0">
        <a routerLink="/" class="flex items-center justify-center space-x-2">
          <img
            src="https://www.laparfumerie.eu/static/version1745586722/frontend/Synolia/laparfumerieeurope/fr_FR/svg/logo.svg"
            alt="La Parfumerie Europe"
            class="h-8 sm:h-10"
          >
        </a>
      </div>

      &lt;!&ndash; Toolbar (Search, Account, Cart) &ndash;&gt;
      <div class="toolbar order-3">
        <div class="inner flex items-center space-x-2 sm:space-x-4">
          <div class="tools flex items-center space-x-2 sm:space-x-4">
            &lt;!&ndash; Search &ndash;&gt;
            <div class="search">
              <button
                (click)="showSearch = true"
                class="text-gray-600 hover:text-gold p-1 sm:p-2"
              >
                <svg
                  class="w-5 h-5 sm:w-6 sm:h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  ></path>
                </svg>
              </button>
            </div>

            &lt;!&ndash; Account &ndash;&gt;
            <div class="account relative">
              <a
                *ngIf="!user; else whenLoggedIn"
                routerLink="/register-login"
                class="text-gray-600 hover:text-gold p-1 sm:p-2"
              >
                <svg
                  class="w-5 h-5 sm:w-6 sm:h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  ></path>
                </svg>
              </a>

              <ng-template #whenLoggedIn>
                <a
                  routerLink="/account/profile"
                  class="text-gray-600 hover:text-gold p-1 sm:p-2 flex items-center space-x-1 sm:space-x-2"
                >
                  <svg
                    class="w-5 h-5 sm:w-6 sm:h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    ></path>
                  </svg>
                  <span class="text-xs sm:text-sm">{{ user?.email }}</span>
                </a>
              </ng-template>

              <ul
                *ngIf="user"
                class="absolute right-0 mt-2 w-48 bg-white text-gray-900 rounded-lg shadow-lg py-2 z-50"
              >
                <li class="px-4 py-2">
                  <div class="text-sm font-serif text-gold">
                    {{ user?.email }}
                    <span
                      *ngIf="user?.roles?.admin"
                      class="text-gray-600"
                    >
                      (Admin)
                    </span>
                  </div>
                </li>
                <li>
                  <a
                    routerLink="/account/profile"
                    href=""
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300"
                  >
                    My Profile
                  </a>
                </li>
                <li>
                  <a
                    routerLink="/account/orders"
                    href=""
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300"
                  >
                    Orders List
                  </a>
                </li>
                <li>
                  <hr class="border-gray-200 mx-2">
                </li>
                <li>
                  <a
                    href=""
                    (click)="onLogOut($event)"
                    class="block px-4 py-2 text-gray-600 hover:bg-gold hover:bg-opacity-10 hover:text-gold transition duration-300 flex items-center space-x-2"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                      ></path>
                    </svg>
                    <span>Logout</span>
                  </a>
                </li>
              </ul>
            </div>

            &lt;!&ndash; Cart &ndash;&gt;
            <app-toolbar-cart></app-toolbar-cart>
          </div>
        </div>
      </div>
    </div>

    &lt;!&ndash; Search Overlay &ndash;&gt;
    <app-search
      (onHideSearch)="showSearch = false"
      [showSearch]="showSearch"
      class="site-search-wrapper"
    ></app-search>

    &lt;!&ndash; Navigation &ndash;&gt;
    <div class="site-menu bg-gray-50 shadow-sm py-2 sm:py-3">
        <app-navigation-main [isMobileMenuOpen]="isMobileMenuOpen"></app-navigation-main>
    </div>
  </div>
</header>
-->


<header class="bg-white shadow-sm">
  <div class="container mx-auto px-4">
    <!-- Top Section -->
    <div class="flex items-center justify-between h-20">
      <!-- Mobile Menu Toggle -->
      <button
        class="lg:hidden text-gray-600 hover:text-gold focus:outline-none p-2"
        (click)="onMenuToggle($event)"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
      </button>

      <!-- Logo -->
      <div class="logo flex-1 text-center lg:text-left">
        <a routerLink="/" class="flex items-center justify-center lg:justify-start">
          <img src="https://www.laparfumerie.eu/static/version1745586722/frontend/Synolia/laparfumerieeurope/fr_FR/svg/logo.svg" alt="La Parfumerie Europe" class="h-10">
        </a>
      </div>

      <!-- Search Bar (Desktop) -->
      <div class="search-bar hidden lg:block absolute left-1/2 transform -translate-x-1/2 max-w-2xl w-full">
        <div class="relative">
          <input
            type="text"
            placeholder="Rechercher..."
            class="w-full h-10 pl-4 pr-10 rounded-full border border-gray-300 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold"
            (input)="onSearchInput($event)"
          >
          <button class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gold">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Toolbar -->
      <div class="toolbar flex items-center space-x-4">
        <!-- Account -->
        <div class="account relative">
          <a
            *ngIf="!user; else whenLoggedIn"
            routerLink="/register-login"
            class="text-gray-600 hover:text-gold p-2"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
            </svg>
          </a>

          <ng-template #whenLoggedIn>
            <a routerLink="/account/profile" class="text-gray-600 hover:text-gold p-2">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
              </svg>
            </a>
          </ng-template>
        </div>

        <!-- Cart -->
        <app-toolbar-cart></app-toolbar-cart>
      </div>
    </div>

    <!-- Search Bar (Mobile) -->
    <div class="search-bar lg:hidden py-2">
      <div class="relative max-w-2xl mx-auto">
        <input
          type="text"
          placeholder="Rechercher..."
          class="w-full h-10 pl-4 pr-10 rounded-full border border-gray-300 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold"
          (input)="onSearchInput($event)"
        >
        <button class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gold">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="site-menu shadow-sm py-2 sm:py-3">
    <app-navigation-main [isMobileMenuOpen]="offcanvasService.offcanvasNavigationOpen | async"></app-navigation-main>
  </div>
</header>

<!-- Search Results Overlay
<app-search
  (onHideSearch)="showSearch = false"
  [showSearch]="showSearch"
  class="site-search-wrapper"
></app-search> -->
